import React, { useEffect, useState } from "react";
import "./login.style.scss";
import { Button, Input } from "antd";
import CircularProgress from "@material-ui/core/CircularProgress";
import { get, post, responseValidator } from "../../api";
import { toast } from "react-toastify";
import moment from "moment";
export default function Login(props) {
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState("");

    useEffect(() => {
    }, [])

    function onCLickHandler() {
        if (localStorage.getItem("phone") && password) {
            setLoading(true);
            post(`/User/Login`, {
                phoneNumber: localStorage.getItem("phone"),
                password: password
            }).then(response => {
                setLoading(false);
                if (responseValidator(response.status)) {
                    localStorage.setItem(
                        "accessToken",
                        response.data.data.token.access_token
                    );
                    localStorage.setItem(
                        "tokenDate",
                        moment.utc()
                    );

                    localStorage.setItem(
                        "refToken",
                        response.data.data.token.refresh_token
                    );
                    localStorage.setItem(
                        "roles",
                        response.data.data.token.roles
                    );
                    localStorage.setItem(
                        "hasNotif",
                        response.data.data.hasNotification
                    );
                    window.location.replace("/userpanel/order");

                } else toast.error(response.data.message);
            });
        }

    }

    function forgotPasswordHandler() {
        setLoading(true);
        post(`/User/SendSmsCode/`, {
            phoneNumber: localStorage.getItem("phone")
        }).then(response => {
            setLoading(false);
            if (responseValidator(response.status)) {
                console.log(response.data.data);
                props.changeState(5);
            } else toast.error(response.data.message);
        });
    }

    return (


        <div className="TEMX-login">
            <h2>وارد کردن رمز عبور</h2>
            <p>
                اکانتی با شماره {localStorage.getItem("phone")} وجود دارد ، برای
                وارد شدن به سایت رمز عبور خود را وارد نمایید
            </p>
            <div className="my-input">
                <Input value={localStorage.getItem("phone")} disabled={true} />
                <span style={{ height: "10px", display: "flex" }} />
                <Input.Password
                    onPressEnter={onCLickHandler}
                    autoComplete={false}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="رمز عبور"
                />
            </div>
            <span style={{ height: "20px", display: "flex" }} />
            <p>
                رمز خود را فراموش کرده اید؟‌
                <a onClick={forgotPasswordHandler}>تغییر رمز عبور</a>
            </p>

            <div className="my-btn">
                <Button
                    loading={loading}
                    block
                    disabled={!localStorage.getItem("phone") || !password}
                    type="primary"
                    onClick={onCLickHandler}
                >
                    ورود
                </Button>
            </div>
        </div>
    );

}
